import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=d2a1e0e2&scoped=true&"
import script from "./Abouts.vue?vue&type=script&lang=js&"
export * from "./Abouts.vue?vue&type=script&lang=js&"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=d2a1e0e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a1e0e2",
  null
  
)

export default component.exports